import './common/pre-init';
import './common/hpe-wc-module';

import 'core/dependencies';
import 'core/helpers/bf-cache-fix';

import {onDocumentReady} from '@exadel/esl/modules/esl-utils/dom/ready';

import {debug} from 'core/log';
import {initComponent} from 'core/helpers/component';
import {initCore} from './legacy.base.init';

import {ChatApi} from 'hpe-chats/core/api';

/*
 * Application start
*/
onDocumentReady(function () {
  debug('System: Start components initialization.');

  initCore();

  initComponent.$if('.hpe-content-block') && initComponent(require('design-3.0/content-block'), '.hpe-content-block');

  initComponent(require('design-3.0/click-to-call'));
  initComponent.$if('.js-page-redirect') && initComponent(require('design-3.0/page-redirect'), '.js-page-redirect');

 initComponent.$if($('image-modal')) && require.ensure('unicorn/image-modal',
            function(require) { initComponent.$if($('image-modal')) && initComponent(require('unicorn/image-modal'), $('image-modal'));;},
            function(error) { require('core/log').error("Can't load unicorn/image-modal", error); },
            'unicorn/image-modal'
            );
 initComponent.$if($('.introduction')) && require.ensure('design-3.0/introduction',
            function(require) { initComponent.$if($('.introduction')) && initComponent(require('design-3.0/introduction'), $('.introduction'));;},
            function(error) { require('core/log').error("Can't load design-3.0/introduction", error); },
            'design-3.0/introduction'
            );
 initComponent.$if($('.valign-txt-only')) && require.ensure('hpe.columns.container',
            function(require) { initComponent.$if($('.valign-txt-only')) && initComponent(require('hpe.columns.container'), $('.valign-txt-only'));;},
            function(error) { require('core/log').error("Can't load hpe.columns.container", error); },
            'hpe.columns.container'
            );

  // CHATS
  ChatApi.load()
    .catch(() => debug('Problem with Chat API loading'));

  // END
  debug('System: All components were initialized.');
});
